import erc20ABI from './erc20ABI';
import liquidityPool from '../json/ILiquidityPool.json';
import tradeManager from '../json/ITradeManager.json';
import tradePair from '../json/ITradePair.json';
import tradePairHelper from '../json/ITradePairHelper.json';
import userManager from '../json/IUserManager.json';

const abis = {
    erc20: erc20ABI,
    liquidityPool: liquidityPool.abi,
    tradeManager: tradeManager.abi,
    tradePair: tradePair.abi,
    tradePairHelper: tradePairHelper.abi,
    userManager: userManager.abi,
};

export default abis;
